export class PessoaMensagemModel {
    constructor(
        public mensagemAosContratos: string = '',
    ) { }
}